
const Partnership = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-cooperation-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const partnershipTypes = [
    {
      icon: 'ri-store-line',
      title: '经销代理',
      description: '成为马帮瑞贡区域经销商，享受优质产品供应和完善的市场支持',
      benefits: ['优惠进货价格', '区域保护政策', '营销支持', '培训服务'],
      bgColor: 'bg-primary',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-building-line',
      title: '企业定制',
      description: '为企业客户提供专属茶品定制服务，打造独特的企业文化礼品',
      benefits: ['个性化配方', '专属包装设计', '批量优惠', '快速交付'],
      bgColor: 'bg-[#603B28]',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-global-line',
      title: '品牌授权',
      description: '授权合作伙伴在指定区域使用马帮瑞贡品牌，共同拓展市场',
      benefits: ['品牌使用权', '技术支持', '运营指导', '共享资源'],
      bgColor: 'bg-slate-600',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-team-line',
      title: '文化合作',
      description: '与文化机构、教育单位合作，共同传播和发展茶文化事业',
      benefits: ['文化交流', '教育合作', '活动支持', '资源共享'],
      bgColor: 'bg-[#3E3A39]',
      iconColor: 'text-accent'
    }
  ];

  const advantages = [
    {
      icon: 'ri-award-line',
      title: '品牌优势',
      description: '三百年历史传承，中央政府采购供应商资质'
    },
    {
      icon: 'ri-shield-check-line',
      title: '品质保证',
      description: '严格的质量管控体系，确保每一款产品的卓越品质'
    },
    {
      icon: 'ri-customer-service-line',
      title: '服务支持',
      description: '专业的团队提供全方位的合作支持和售后服务'
    },
    {
      icon: 'ri-rocket-line',
      title: '发展前景',
      description: '茶产业蓬勃发展，与我们携手共创美好未来'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-gray-50">
      <div className="px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* 左侧内容 */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                产品代理合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                成为马帮瑞贡区域代理商，享受优质产品供应、品牌支持和营销资源，共同开拓茶叶市场。
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                渠道拓展合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                与我们建立渠道合作关系，通过线上线下多元化销售网络，实现互利共赢的长期发展。
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                文化交流合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                传承马帮茶文化，开展茶艺培训、文化活动等合作项目，共同推广中华茶文化。
              </p>
            </div>
          </div>

          {/* 右侧内容 */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                定制服务合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                提供个性化茶叶定制服务，满足企业礼品、会议用茶等特殊需求，打造专属茶品。
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                品牌授权合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                授权使用马帮瑞贡品牌，在指定区域内开展茶叶销售业务，享受品牌价值带来的市场优势。
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-primary mb-3 font-serif">
                供应链合作
              </h3>
              <p className="text-gray-600 leading-relaxed">
                建立稳定的供应链合作关系，确保优质茶叶原料供应，共同维护产品品质标准。
              </p>
            </div>
          </div>
        </div>

        {/* 合作优势 */}
        <div className="mt-12 lg:mt-16">
          <h3 className="text-2xl font-bold text-primary text-center mb-8 font-serif">
            合作优势
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-lg font-semibold text-primary mb-2">品牌实力</h4>
              <p className="text-gray-600 text-sm">
                三百年马帮传承，深厚的品牌底蕴和市场认知度
              </p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-lg font-semibold text-primary mb-2">产品优势</h4>
              <p className="text-gray-600 text-sm">
                精选云南优质茶叶，严格品质控制，产品竞争力强
              </p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-lg font-semibold text-primary mb-2">服务支持</h4>
              <p className="text-gray-600 text-sm">
                专业团队提供全方位支持，助力合作伙伴成功
              </p>
            </div>
          </div>
        </div>

        {/* 行动号召 */}
        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl p-8 lg:p-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-primary mb-4 font-serif">
              开启合作之旅
            </h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              马帮瑞贡诚邀各界伙伴加入我们的合作大家庭，共同传承茶文化，创造商业价值，实现互利共赢的美好未来。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={scrollToForm}
                className="bg-accent hover:bg-accent/90 text-primary px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                立即咨询
              </button>
              <a
                href="tel:400-888-8888"
                className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                电话咨询
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnership;
